// ============================================================================
// Hex Formatting Utilities
// ============================================================================

/**
 * Format a number as a hex string with 0x prefix.
 */
export function toHex(value: number, padLength: number = 8): string {
  return '0x' + value.toString(16).toUpperCase().padStart(padLength, '0');
}

/**
 * Format a Uint8Array as a hex dump string.
 * Output format: "00000000  48 65 6C 6C 6F 20 57 6F  72 6C 64 21 00 00 00 00  |Hello World!....|"
 */
export function formatHexDump(data: Uint8Array, baseAddress: number = 0, bytesPerLine: number = 16): string {
  const lines: string[] = [];

  for (let offset = 0; offset < data.length; offset += bytesPerLine) {
    const addr = (baseAddress + offset).toString(16).toUpperCase().padStart(8, '0');
    const chunk = data.slice(offset, offset + bytesPerLine);

    // Hex bytes
    const hexParts: string[] = [];
    for (let i = 0; i < bytesPerLine; i++) {
      if (i < chunk.length) {
        hexParts.push(chunk[i].toString(16).toUpperCase().padStart(2, '0'));
      } else {
        hexParts.push('  ');
      }
    }
    const hexLeft = hexParts.slice(0, 8).join(' ');
    const hexRight = hexParts.slice(8).join(' ');

    // ASCII representation
    let ascii = '';
    for (let i = 0; i < chunk.length; i++) {
      ascii += chunk[i] >= 0x20 && chunk[i] <= 0x7E ? String.fromCharCode(chunk[i]) : '.';
    }

    lines.push(`${addr}  ${hexLeft}  ${hexRight}  |${ascii}|`);
  }

  return lines.join('\n');
}

/**
 * Parse a hex string (with or without "0x" prefix) to a number.
 */
export function parseHexString(hex: string): number {
  const cleaned = hex.replace(/^0x/i, '').replace(/\s/g, '');
  return parseInt(cleaned, 16);
}
